<template>
    
    <v-card hover class="template-card flip-container" ontouchstart="this.classList.toggle('hover');" >
        <div class="flipper">
            <div style="width:100%;" class="front" >
            <p style="min-height:82px; padding-top:50px;" class="headline text-center">{{item.owner}}</p>
            <p style="min-height:25px;" class="subheading text-center">{{item.name}}</p> 
            <p style="min-height:20px;" class="font-weight-bold body-1 text-center" >{{item.subtitle}}</p>              
                                    
            <p style="padding:0px; margin:0px;" class="text-center caption">Versie: {{item.version}}</p>                                   
            <p style="padding-bottom:25px;" class="text-center caption">Redactie : {{item.editor}}</p>
                                    
            </div>
            <div style="width:100%;" class="back">
            <p style="min-height:82px; padding-top:50px;" class="headline text-center">{{item.owner}}</p>
            <p style="min-height:25px;" class="subheading text-center">{{item.name}}</p> 
            <p style="min-height:20px;" class="font-weight-bold body-1 text-center" >{{item.subtitle}}</p>              

            <v-container justify-center="">
                <v-layout class="pa-2">
                <v-btn block :color="app.color" @click="createContract(item.reference)" rounded>aanmaken</v-btn>
                </v-layout>
            </v-container>
            </div>
        </div>
    </v-card>

</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      default: undefined,
      required: true
    },
    source: {
      type: String,
      default: undefined,
      required: true
    }
  },
  methods: {
    createContract(template) {
      if (this.source == "contracts") {
        this.$store.dispatch("createUndefinedContract", {
          parent: this.object.reference,
          template: template
        });
      }
    }
  },
  computed: {
    ...mapState(["app", "object"])
  }
};
</script>


<style scoped>
.template-card {
  height: 100%;
  border-radius: 20px;
}

/* entire container, keeps perspective */
.flip-container {
  perspective: 1000px;
}
/* flip the pane when hovered */
.flip-container:hover .flipper,
.flip-container.hover .flipper {
  transform: rotateY(180deg);
}

/* flip speed goes here */
.flipper {
  transition: 0.4s;
  transform-style: preserve-3d;

  position: relative;
}

/* hide back of pane during swap */
.front,
.back {
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
}

/* front pane, placed above back */
.front {
  z-index: 2;
  /* for firefox 31 */
  transform: rotateY(0deg);
}

/* back, initially hidden pane */
.back {
  transform: rotateY(180deg);
}
</style>
